import React, { useState } from 'react';
import { skillsData } from '../utils/constants';
import { CodeIcon, GlobeIcon, HeartIcon } from 'lucide-react';
const Skills = ({
  language = 'en'
}) => {
  const [hoveredLanguage, setHoveredLanguage] = useState(null);
  const translations = {
    en: {
      skills: 'Skills &',
      interests: 'Interests',
      languages: 'Languages',
      technicalSkills: 'Technical Skills',
      interestsTitle: 'Interests'
    },
    vi: {
      skills: 'Kỹ Năng &',
      interests: 'Sở Thích',
      languages: 'Ngôn Ngữ',
      technicalSkills: 'Kỹ Năng Kỹ Thuật',
      interestsTitle: 'Sở Thích'
    }
  };
  const t = translations[language];
  return <section id="skills" className="w-full py-24 bg-secondary" data-id="element-1019">
      <div className="container mx-auto px-4" data-id="element-1020">
        <h2 className="text-3xl md:text-4xl font-display font-bold text-center mb-16 animate-pulse" data-id="element-1021">
          {t.skills} <span className="gradient-text" data-id="element-1022">{t.interests}</span>
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1023">
          <div className="bg-background rounded-2xl p-6 card-glow transform transition-all duration-500 hover:scale-105" data-id="element-1024">
            <div className="flex items-center gap-3 mb-6" data-id="element-1025">
              <GlobeIcon size={24} className="text-accent-cyan animate-spin-slow" data-id="element-1026" />
              <h3 className="text-2xl font-display font-bold" data-id="element-1027">{t.languages}</h3>
            </div>
            <div className="space-y-6" data-id="element-1028">
              {skillsData.languages.map((language, index) => <div key={index} className="relative group cursor-pointer" onMouseEnter={() => setHoveredLanguage(language)} onMouseLeave={() => setHoveredLanguage(null)} data-id="element-1029">
                  <div className="flex justify-between items-center mb-2" data-id="element-1030">
                    <p className="text-lg" data-id="element-1031">{language}</p>
                    <div className="relative" data-id="element-1032">
                      {hoveredLanguage === language && <div className="absolute -top-14 right-0 bg-secondary/90 backdrop-blur-sm rounded-lg p-2 shadow-lg text-sm z-10 min-w-[120px] transform transition-all duration-300 scale-in active" data-id="element-1033">
                          {language === 'English' ? <p data-id="element-1034">Tiếng Anh</p> : <p data-id="element-1035">Vietnamese</p>}
                          <div className="absolute bottom-[-8px] right-2 w-4 h-4 bg-secondary rotate-45" data-id="element-1036"></div>
                        </div>}
                    </div>
                  </div>
                  <div className="w-full h-2 bg-secondary rounded-full overflow-hidden" data-id="element-1037">
                    <div className="h-full bg-gradient-to-r from-accent-cyan to-accent-violet animate-pulse-slow" style={{
                  width: skillsData.languagesTranslation[language].proficiency
                }} data-id="element-1038"></div>
                  </div>
                </div>)}
            </div>
          </div>
          <div className="bg-background rounded-2xl p-6 card-glow transform transition-all duration-500 hover:scale-105" data-id="element-1039">
            <div className="flex items-center gap-3 mb-6" data-id="element-1040">
              <CodeIcon size={24} className="text-accent-violet animate-bounce-slow" data-id="element-1041" />
              <h3 className="text-2xl font-display font-bold" data-id="element-1042">
                {t.technicalSkills}
              </h3>
            </div>
            <div className="flex flex-wrap gap-2" data-id="element-1043">
              {skillsData.technical.map((skill, index) => <span key={index} className="px-3 py-1 rounded-full bg-secondary text-primary text-sm border border-accent-cyan/30 transform transition-all duration-300 hover:scale-110 hover:border-accent-cyan hover:bg-secondary/80" style={{
              animationDelay: `${index * 0.1}s`
            }} data-id="element-1044">
                  {skill}
                </span>)}
            </div>
          </div>
          <div className="bg-background rounded-2xl p-6 card-glow transform transition-all duration-500 hover:scale-105" data-id="element-1045">
            <div className="flex items-center gap-3 mb-6" data-id="element-1046">
              <HeartIcon size={24} className="text-accent-amber animate-pulse" data-id="element-1047" />
              <h3 className="text-2xl font-display font-bold" data-id="element-1048">
                {t.interestsTitle}
              </h3>
            </div>
            <div className="grid grid-cols-2 gap-4" data-id="element-1049">
              {skillsData.interests.map((interest, index) => <div key={index} className="flex items-center gap-2 transform transition-all duration-300 hover:translate-x-2" style={{
              animationDelay: `${index * 0.1}s`
            }} data-id="element-1050">
                  <span className="text-accent-cyan animate-pulse-slow" data-id="element-1051">•</span>
                  <span data-id="element-1052">{interest}</span>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default Skills;